import { Component, OnInit } from '@angular/core';
import { IInvitation } from '@app/models/signup';
import { translate } from '@ngneat/transloco';

interface IFooterTool {
  title: string;
  description: string;
  assetUrl: string;
  focused: boolean;
}

@Component({
  selector: 'signup-landing-footer',
  templateUrl: './signup-landing-footer.component.html',
  styleUrls: ['./signup-landing-footer.component.scss']
})
export class SignupLandingFooterComponent implements OnInit {
  invitation: IInvitation;

  workspace: IFooterTool[] = [
    {
      title: 'Mail',
      description: translate('Gerez vos mails en ligne, creez des filtres intelligents et configurez vos adresses sur vos appareils.'),
      assetUrl: '/assets/images/ui/tools/ik-mail.svg',
      focused: false
    },
    {
      title: 'Calendar',
      description: translate('Gerez vos rendez-vous, accedez a vos agendas partages et synchronisez vos evenements sur vos appareils.'),
      assetUrl: '/assets/images/ui/tools/ik-calendar.svg',
      focused: false
    },
    {
      title: 'Contacts',
      description: translate('Gerez vos contacts, accedez a vos carnets d\'adresses partages et synchronisez vos donnees sur vos appareils.'),
      assetUrl: '/assets/images/ui/tools/ik-contacts.svg',
      focused: false
    },
    {
      title: 'SMS',
      description: translate('Envoyez des SMS depuis votre navigateur et creez des alarmes basees sur votre messagerie.'),
      assetUrl: '/assets/images/ui/tools/ik-sms.svg',
      focused: false
    },
    {
      title: 'Notes',
      description: translate('Gerez vos notes, creez des listes de choses a faire et synchronisez vos memos sur vos appareils.'),
      assetUrl: '/assets/images/ui/tools/ik-tasks.svg',
      focused: false
    },
    {
      title: 'Meet',
      description: translate('Organisez des videoconferences en toute securite depuis tous vos appareils.'),
      assetUrl: '/assets/images/ui/tools/ik-meet.svg',
      focused: false
    }
  ];

  storage: IFooterTool[] = [
    {
      title: 'kDrive',
      description: translate('Stockez vos donnees en securite, editez vos documents Office en ligne et collaborez facilement avec vos equipes.'),
      assetUrl: '/assets/images/ui/tools/ik-drive.svg',
      focused: false
    }
  ];

  onlyOffice: IFooterTool[] = [
    {
      title: translate('Feuilles de calcul'),
      description: translate('Editez vos feuilles de calcul en ligne, collaborez a plusieurs en temps reel et partagez facilement votre travail.'),
      assetUrl: '/assets/images/ui/tools/ik-grids.svg',
      focused: false
    },
    {
      title: translate('Documents'),
      description: translate('Editez vos documents texte en ligne, collaborez a plusieurs en temps reel et partagez facilement votre travail.'),
      assetUrl: '/assets/images/ui/tools/ik-docs.svg',
      focused: false
    },
    {
      title: translate('Presentations'),
      description: translate('Editez vos presentations en ligne, collaborez a plusieurs en temps reel et partagez facilement votre travail.'),
      assetUrl: '/assets/images/ui/tools/ik-points.svg',
      focused: false
    }
  ];

  collaborate: IFooterTool[] = [
    {
      title: translate('Gestion des utilisateurs'),
      description: translate('Gerez les utilisateurs de votre organisation.'),
      assetUrl: '/assets/images/ui/tools/ik-management-users.svg',
      focused: false
    },
    {
      title: translate('Gestion de la comptabilite'),
      description: translate('Payez vos factures, gerez vos moyens de paiement et consultez l\'historique de vos factures.'),
      assetUrl: '/assets/images/ui/tools/ik-management-accounting.svg',
      focused: false
    },
    {
      title: translate('Gestion des produits'),
      description: translate('Gerez facilement tous les produits de votre organisation au meme endroit.'),
      assetUrl: '/assets/images/ui/tools/ik-management-products.svg',
      focused: false
    }
  ];

  constructor() {
  }

  ngOnInit() {
    this.invitation = window['INVITATION'];
  }

}
